import { useAuthStateStore } from '@annunciate/core';
import { getLocalProgress } from './getLocalProgress';
;
export const resolveRemoteAndLocalSyncs = async (client, remoteProgress) => {
    const uuid = useAuthStateStore.getState().getUUID(true);
    const updatedProgress = getLocalProgress(client, uuid || 'public');
    const localMap = updatedProgress.reduce((acc, val) => {
        const data = val[1];
        if (data) {
            acc[`${uuid}:${data.contentId}`] = data;
        }
        return acc;
    }, {});
    const resolved = remoteProgress.reduce((acc, remote) => {
        const key = `${uuid}:${remote.contentId}`;
        const local = localMap[key];
        const remoteUpdatedAt = remote?.updatedAt ? new Date(remote.updatedAt) : 0;
        const localUpdatedAt = local?.updatedAt ? new Date(local.updatedAt) : 0;
        if (!local || remoteUpdatedAt > localUpdatedAt) {
            acc.local.push(remote);
        }
        else if (local) {
            acc.remote.push(local);
        }
        if (local) {
            delete localMap[key];
        }
        return acc;
    }, {
        remote: [],
        local: [],
    });
    resolved.remote.push(...Object.values(localMap));
    return resolved;
};
//# sourceMappingURL=resolveRemoteAndLocalSyncs.js.map